import React from 'react';
import {styled} from "styled-components";
import logo from '../../assets/logo.svg';
import {useNavigate} from "react-router";
import useDataStore from "../../data/store/useDataStore";
import { t } from 'ttag';

const Section = styled.div`
  text-align: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
  p {
    font-family: Recoleta;
    color: rgb(151, 56, 255);
    font-size: 22px;
    font-weight: 800;
    b {
      color: #000;
      padding-right: 10px;
    }
  }
  img {
    margin-top: -12px;
  }
`;

const HelpLineTitle = () => {
  const navigate = useNavigate();
  const { companyId } = useDataStore();

  return (
    <Section className='HelpLineTitle mb-3' onClick={() => navigate(`/${companyId || ''}`)}>
      <p>{t`Anonymous Reporting`} <b>{t`by`}</b></p>
      <img src={logo} alt="EasyLlama" />
    </Section>
  );
};

export default HelpLineTitle;
